module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("添加跟踪记录-绑定有效时间生效失败记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRules,
      "label-width": 90
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "sm": 11,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formData.uid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "uid", _vm._n($$v))
      },
      expression: "formData.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formData.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nickname", $$v)
      },
      expression: "formData.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formData.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "adviserName", $$v)
      },
      expression: "formData.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formData.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "studyAdviserName", $$v)
      },
      expression: "formData.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "20"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "开课时间生效失败原因"
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期",
      "prop": "nextHandlerTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value": _vm.formData.nextHandlerTime
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人",
      "prop": "nextHandlerId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.formData.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nextHandlerId", _vm._n($$v))
      },
      expression: "formData.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "operateStatus"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.operateStatus),
      callback: function($$v) {
        _vm.$set(_vm.formData, "operateStatus", $$v)
      },
      expression: "formData.operateStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未处理")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已处理")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6180d182","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/BindingValidTimeFailRecords.vue
// module id = 1847
// module chunks = 8